<template>
  <div class="viewDialog">
    <BaseDialog title="结算" :isshow="visible" @handleShow="(val) => {visible = val }" width="85%" height="auto">
      <div class="patentList fatherHeight contBox">
        <div>
          <div class="patentList fatherHeight contBox ">
            <div class="momey-total display_flex" style="font-size: 16px;font-weight: bold;">
              <div class="item">姓名:{{info.name}}</div>
              <div class="item1">身份证号:{{info.cert_no}}</div>
              <div class="item">年龄:{{info.age}}</div>
          
            </div>
          </div>
          <!-- <div class="search-top">
            <div class="bar-title">结算信息</div>
            <el-form :inline="true" :model="formData" ref="formDataRef" :rules="JsRule" class="demo-form-inline"
              :label-width="120" label-suffix=":">
              <el-form-item label="结算类别" prop="dict_pay_cate">
                <el-select v-model="formData.dict_pay_cate" placeholder="请选择">
                  <el-option v-for="item in resultList" :key="item.id" :label="item.name"
                    :value="item.code"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div> -->
        </div>
        <el-divider></el-divider>
        <div class="patientList">
          <div class="list-top flex-between">
            <div class="bar-title">
              <el-radio-group v-model="pageData.dict_catalog_type" @change="radioChange">
                <el-radio v-for="(item,index) in cfArr" :key="index" :label="item.id">
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
            </div>
          </div>
          <div class="table" ref="tableBoxRef">
            <el-table v-loading="dataListLoading" :data="tableData" class="table-ellipsis" v-if="istable" size="small"
              border @selection-change="handleSelectionChange" max-height="300">
              <el-table-column type="selection" align="center" width="42" />
              <el-table-column label="序号" width="80" type="index" align="center" />
              <el-table-column prop="name" label="名称" width="300" />
              <el-table-column width="100" label="医保报销">
                <template #default="scope">
                  <el-checkbox v-model="scope.row.pay_typeCheck" label="" disabled></el-checkbox>
                </template>
              </el-table-column>
              <el-table-column prop="medi_spec" label="规格" />
              <el-table-column prop="sell_price" label="单价" />
              <el-table-column prop="num" label="数量" />
              <el-table-column prop="num_unit_name" label="单位" />
              <el-table-column prop="total_price" label="金额" />
            </el-table>
            <div class="momey-total">
              <div class="item">药品:{{free.yao.toFixed(2)}}</div>
              <div class="item">耗材:{{free.hao.toFixed(2)}}</div>
              <div class="item">治疗项目:{{free.zhi.toFixed(2)}}</div>
            </div>
            <div class="momey-total" style="font-size: 16px;font-weight: bold;">
              <div class="item">合计:{{totalMoney.toFixed(2)}}</div>
              <div class="item1">大写:{{totalMoneyBig}}</div>
            </div>
          </div>
        </div>
      </div>
      <template #footer>
        <div class="dialog-footer">
          <el-button class="color-cancel" type="primary" @click="visible = false">
            取消
          </el-button>
          <el-button @click="savePatient" :disabled="saveType==1?true:false" :loading="saveLoad" class="color-determine"
            type="primary">
            确定
          </el-button>
        </div>
      </template>
    </BaseDialog>
  </div>
</template>
<script setup name="jieShuan">
  import {
    reactive,
    toRefs,
    ref,
    nextTick,
    onMounted,
    onBeforeUnmount, defineEmits, getCurrentInstance
  } from 'vue'
  import { useRouter, useRoute } from 'vue-router'
  import service from '@/utils/request'
  import { chineseNumber } from '@/utils/tool'
  import { ElMessageBox, ElMessage } from 'element-plus'
  import BaseDialog from '@/components/Dialog/index.vue'

  const { proxy } = getCurrentInstance()
  const visible = ref(false)
  const saveLoad = ref(false)
  const saveType = ref(0)
  const emit = defineEmits(["jsConfirm"])
  const cfArr = ref([
    { name: '全部', id: '' },
    { name: '处方', id: '160000000' },
    { name: '处置', id: '164000000,161000000' },
  ])
  
  const info = ref({})
  const cfArrValue = ref([])
  const totalMoney = ref(0)
  const totalMoneyBig = ref(0)
  const free = ref({ yao: 0, hao: 0, zhi: 0 })
  const resultList = ref([{
    id: '1',
    name: '自费',
    code: '1001'
  }, {
    id: '2',
    name: '医保',
    code: '4040'
  }])
  const JsRule = ref(
    {
      dict_pay_cate: [
        { required: true, trigger: 'blur', message: '请选择' },
      ]
    }
  )
  async function savePatient() {
    // proxy.$refs.formDataRef.validate(async (valid) => {
    //   if (valid) {
        saveLoad.value = true
       
          let data = {
            ...info.value,
            ...formData.value,
            pay_data: tableSelected.value,
            dict_catalog_type: pageData.dict_catalog_type,
            totalMoney: totalMoney.value,
            typeDo: 'result',
            dict_pay_cate: info.value.dict_pay_cate
          }
          let res = await service.post(
            '/api/medical/save_fee_info',
            data
          )

          if (res.code === 0) {
            saveLoad.value = false
            saveType.value = 1
            ElMessage.success(res.msg)
            visible.value = false
            console.log(111,data)
            emit('jsConfirm', data)
            free.value.yao = 0
            free.value.hao = 0
            free.value.zhi = 0
            totalMoney.value = 0
            totalMoneyBig.value = chineseNumber(0)
          } else {
            saveLoad.value = false
          }
        
    //   } else {
    //     return false
    //   }
    // })
  }
  function radioChange(e) {
    console.log(e)
    pageData.value.dict_catalog_type = e
    getDataList(info.value.bed_reg_id)
    free.value.yao = 0
    free.value.hao = 0
    free.value.zhi = 0
    totalMoney.value = 0
    totalMoneyBig.value = chineseNumber(0)
  }
  // 复选框
  function handleSelectionChange(e) {
    tableSelected.value = e
    let arr = JSON.parse(JSON.stringify(e))
    if (arr.length > 0) {
      if (pageData.value.dict_catalog_type == '160000000') {
        let total = arr.reduce((pre, cur) => {
          return pre + (Number(cur.sell_price) * Number(cur.num))
        }, 0)
        free.value.yao = total
        free.value.hao = 0
        free.value.zhi = 0
        totalMoney.value = total
      } else if (pageData.value.dict_catalog_type == '164000000,161000000') {
        let haoArr = []
        let zhiArr = []
        arr.forEach(element => {
          if (element.dict_catalog_type == '164000000') {
            haoArr.push(element)
          } else {
            zhiArr.push(element)
          }
        });
        console.log(zhiArr, haoArr)
        let totalHao = haoArr.reduce((pre, cur) => {
          return pre + (Number(cur.sell_price) * Number(cur.num))
        }, 0)
        let totalZhi = zhiArr.reduce((pre, cur) => {
          return pre + (Number(cur.sell_price) * Number(cur.num))
        }, 0)
        free.value.yao = 0
        free.value.hao = totalHao
        free.value.zhi = totalZhi
        totalMoney.value = totalHao + totalZhi
        // 这是耗材与治疗项
      } else {
        let yaoArr = []
        let haoArr = []
        let zhiArr = []
        arr.forEach(element => {
          if (element.dict_catalog_type == '164000000') {
            haoArr.push(element)
          } else if (element.dict_catalog_type == '161000000') {
            zhiArr.push(element)
          } else {
            yaoArr.push(element)
          }
        });
        console.log(zhiArr, haoArr)
        let totalHao = haoArr.reduce((pre, cur) => {
          return pre + (Number(cur.sell_price) * Number(cur.num))
        }, 0)
        let totalZhi = zhiArr.reduce((pre, cur) => {
          return pre + (Number(cur.sell_price) * Number(cur.num))
        }, 0)
        let totalYao = yaoArr.reduce((pre, cur) => {
          return pre + (Number(cur.sell_price) * Number(cur.num))
        }, 0)
        free.value.yao = totalYao
        free.value.hao = totalHao
        free.value.zhi = totalZhi
        totalMoney.value = totalHao + totalZhi + totalYao
      }
      totalMoneyBig.value = chineseNumber(totalMoney.value)
    } else {
      free.value.yao = 0
      free.value.hao = 0
      free.value.zhi = 0
      totalMoney.value = 0
      totalMoneyBig.value = chineseNumber(0)
    }
  }


  const router = useRouter()
  const route = useRoute()
  const searchData = ref(
    {
      case_no: '',
      name: '',
      cert_no: '',
      birth_date: '',
      dict_medical_cate: '',
      doctor_id: '',
      dict_department: ''
    }
  )
  const formData = ref({
    dict_pay_cate: ''
  })
  const pageData = ref({
    bed_reg_id: '',
    dict_catalog_type: ''
  })
  const dataListLoading = ref(false)
  const tableData = ref([])
  const tableSelected = ref([])
  const dictList = ref({})
  const searchForm = ref({})
  const statistic = ref('')
  const istable = ref(true)
  const tableBoxRef = ref(null)
  const tableHei = ref(0)

  onMounted(() => {
    istable.value = false
    // tableHei.value = tableBoxRef.value.clientHeight - 40
    nextTick(() => {
      istable.value = true
    })

  })


  const getDataList = async (id) => {
    pageData.value.bed_reg_id = id
    dataListLoading.value = true
    let res = await service.post(
      '/api/medical/settle_accounts_list',
      pageData.value
    )
    dataListLoading.value = false
    if (res.code === 0) {
      tableData.value = res.data
      tableData.value.forEach(item => {
        if (item.pay_type == '1') {
          item.pay_typeCheck = true
        } else {
          item.pay_typeCheck = false
        }
      })
      statistic.value = '总金额:123  待结算金额:123 已退费金额:123 病人待结算金额:123'
    }
  }
  //医保报销
  const adviceDoChe = async (val, row) => {
    console.log(val, row)
    if (row.pay_typeCheck) {
      row.pay_type = '1'
    } else {
      row.pay_type = '2'
    }
  }
  defineExpose({
    visible,
    info,
    getDataList,
    saveType,
  })
</script>
<style lang="scss">
  .el-notification__group {
    flex: 1;
  }

  .notice_but {
    text-align: right;
    color: #3167a8;
    cursor: pointer;
  }
</style>
<style scoped lang="scss">
  .demo-form-inline {
    margin-top: 0;
    //flex: 1;
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-row-gap: 10px;
    //grid-template-rows: repeat(4, 40px);
    align-items: center;

    .el-form-item {
      margin-bottom: 0;
    }
  }

  .search-top .w-208 {
    width: 208px;
  }

  .table-tag {
    margin-right: 8px;
  }

  .fa-stack {
    width: 24px;
    height: 24px;
    cursor: pointer;
    float: right;

    .fa-stack-2x {
      font-size: 24px;
      color: rgba(49, 102, 174, 0.1);
    }

    .fa-stack-1x {
      font-size: 12px;
      color: #3166ae;
      line-height: 24px;
    }
  }

  .tagBox {
    display: flex;
    justify-content: flex-start;

    // margin-bottom: 10px;
    .tit {
      width: 83px;
      font-size: 14px;
      font-family: 'Source Han Sans CN-Bold';
      font-weight: bold;
      color: #666666;
    }

    .cont {
      width: calc(100% - 83px);
    }
  }

  .patientList {
    margin-top: 4px;
    height: calc(100% - 45px);
  }

  .list-top {
    .name {
      font-size: 18px;
      font-family: ' Source Han Sans CN-Medium';
      font-weight: 500;
      color: #000000;
      line-height: 32px;
    }
  }

  .patient-alert {
    background: rgba(49, 102, 174, 0.1);
    border-radius: 4px 4px 4px 4px;
    font-size: 18px;
    color: #3166ae;
    margin-top: 8px;
    padding: 4px 16px;

    .el-alert__icon {
      color: #3166ae;
    }

    &:deep(.el-alert__content) {
      position: relative;
      top: 3px;
    }
  }

  .table {
    margin-top: 10px;
    height: calc(100% - 82px);

    .img {
      width: 25px;
      height: 24px;
      margin-right: 14px;
    }
  }

  .searchBut {
    width: 100%;
    //margin-left: 20px;
    //margin-right: 29px;
    justify-self: right;
    display: flex;
    justify-content: end;
    margin-right: 28px;
  }

  .del {
    background-color: #ffecec;
    color: #ff6b6b;
    font-weight: 700;
  }

  .modify {
    background-color: #3166ae;
  }

  .bar-title {
    font-size: 18px;
    line-height: 18px;
    color: #000000;
    border-left: 6px solid #3166ae;
    padding: 0 18px;
    margin-bottom: 16px;
    font-weight: bold;
  }

  .momey-total {
    display: flex;
    margin: 10px;
    line-height: 30px;
    justify-content: space-between;
    align-items: center;
    .item {
      margin-right: 20px;
      width: 180px;
    }

    .item1 {
      width: 300px;
    }
  }

  .radio-bg {
    background: rgba(49, 102, 174, 0.1);
    padding: 0px 10px;
    border-radius: 4px;
  }
</style>